import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PendingChangesGuard} from 'src/app/common/can-deactivate/pending-changes-guard.service';
import {AlarmDefinitionFormComponent} from './alarm-definition/alarm-definition-form/alarm-definition-form.component';
import {MaintenanceComponent} from './maintenance.component';

const routes: Routes = [
  {path: '', component: MaintenanceComponent},
  {path: 'new', component: AlarmDefinitionFormComponent, data: {mode: 'create'}, canDeactivate: [PendingChangesGuard]},
  {
    path: ':alarmDefinitionUuid/edit',
    component: AlarmDefinitionFormComponent,
    data: {mode: 'edit'},
    canDeactivate: [PendingChangesGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MaintenanceRoutingModule {
}
